var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ueiighycha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15566",
    style: {
      fill: "none"
    },
    d: "M0 0h60v70H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59830",
    d: "m0 38.841 4.5 3.765v-3.765z",
    transform: "translate(0 -11.227)",
    style: {
      fill: "#664039"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 899"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 898",
    style: {
      clipPath: "url(#ueiighycha)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59831",
    d: "M44.456 0H8.789a3.4 3.4 0 0 0-3.378 3.419v63.163A3.4 3.4 0 0 0 8.789 70h49.442a3.4 3.4 0 0 0 3.378-3.418V17.453a.712.712 0 0 0-.2-.5L44.955.21a.7.7 0 0 0-.5-.21",
    transform: "translate(-1.61)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59832",
    d: "M58.529 69.578H9.086a2.692 2.692 0 0 1-2.675-2.708V3.707A2.692 2.692 0 0 1 9.086 1h35.668L61.2 17.742V66.87a2.692 2.692 0 0 1-2.676 2.708",
    transform: "translate(-1.907 -.289)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15561",
    transform: "translate(15.471 34.289)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15562",
    transform: "translate(15.471 42.829)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15563",
    transform: "translate(15.471 51.369)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15564",
    transform: "translate(15.471 59.91)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15565",
    transform: "translate(0 11.904)",
    style: {
      fill: "#a87c69"
    },
    d: "M0 0h34.523v15.71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59833",
    d: "M17 26.662h-2.761v2.1h3.232v.938h-4.4v-6.809h4.368v.955h-3.2v1.88H17z",
    transform: "translate(-3.888 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59834",
    d: "M25.618 23.846h-2.1V29.7h-1.16v-5.854h-2.08v-.955h5.34z",
    transform: "translate(-6.032 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59835",
    d: "M34.132 27.447a2.474 2.474 0 0 1-.8 1.7 2.688 2.688 0 0 1-1.844.611 2.607 2.607 0 0 1-1.417-.386 2.526 2.526 0 0 1-.946-1.1 4 4 0 0 1-.346-1.652v-.636a4.027 4.027 0 0 1 .337-1.7 2.564 2.564 0 0 1 .969-1.133 2.676 2.676 0 0 1 1.458-.4 2.4 2.4 0 0 1 2.589 2.349h-1.164a1.693 1.693 0 0 0-.423-1.059 1.389 1.389 0 0 0-1-.325 1.362 1.362 0 0 0-1.173.564 2.846 2.846 0 0 0-.417 1.655v.6a3.02 3.02 0 0 0 .39 1.686 1.291 1.291 0 0 0 1.144.58 1.5 1.5 0 0 0 1.036-.313 1.645 1.645 0 0 0 .439-1.044z",
    transform: "translate(-8.562 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59836",
    d: "M17.248 30.019h-4.4a.53.53 0 0 1-.527-.533v-6.812a.53.53 0 0 1 .527-.533h4.368a.53.53 0 0 1 .527.533v.955a.53.53 0 0 1-.527.533h-2.672v.813h2.238a.53.53 0 0 1 .527.533v.936a.53.53 0 0 1-.527.533h-2.238v1.029h2.7a.53.53 0 0 1 .527.533v.945a.53.53 0 0 1-.527.533m-3.873-1.066h.307a.538.538 0 0 1-.192-.412v-2.1a.533.533 0 0 1 .275-.469.532.532 0 0 1-.275-.468v-1.88a.537.537 0 0 1 .2-.422h-.318z",
    transform: "translate(-3.665 -6.4)",
    style: {
      fill: "#664039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59837",
    d: "M23.295 30.019h-1.16a.53.53 0 0 1-.527-.533v-5.324h-1.553a.53.53 0 0 1-.527-.533v-.955a.53.53 0 0 1 .527-.533h5.34a.53.53 0 0 1 .527.533v.955a.53.53 0 0 1-.527.533h-1.573v5.324a.53.53 0 0 1-.527.533m-.633-1.066h.106v-5.324a.537.537 0 0 1 .2-.422h-.514a.535.535 0 0 1 .2.422z",
    transform: "translate(-5.809 -6.4)",
    style: {
      fill: "#664039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59838",
    d: "M31.269 30.075a3.131 3.131 0 0 1-1.7-.467 3.062 3.062 0 0 1-1.144-1.321 4.568 4.568 0 0 1-.4-1.872v-.644a4.569 4.569 0 0 1 .387-1.923 3.1 3.1 0 0 1 1.168-1.36 3.206 3.206 0 0 1 1.737-.478 2.922 2.922 0 0 1 3.108 2.819.537.537 0 0 1-.133.411.526.526 0 0 1-.391.176h-1.158a.53.53 0 0 1-.523-.472 1.239 1.239 0 0 0-.262-.734.911.911 0 0 0-.634-.178.837.837 0 0 0-.747.347 2.365 2.365 0 0 0-.315 1.344v.6a2.529 2.529 0 0 0 .3 1.386.768.768 0 0 0 .707.347 1.039 1.039 0 0 0 .684-.178 1.183 1.183 0 0 0 .268-.714.529.529 0 0 1 .523-.465h1.165a.525.525 0 0 1 .39.174.537.537 0 0 1 .135.409 3 3 0 0 1-.974 2.053 3.21 3.21 0 0 1-2.191.742m1.907-2.311a2.111 2.111 0 0 1-.306.668 1.745 1.745 0 0 0 .4-.668zm-3.451-4.014a2.254 2.254 0 0 0-.35.548 3.516 3.516 0 0 0-.288 1.473v.636a3.485 3.485 0 0 0 .3 1.423 2.2 2.2 0 0 0 .348.535c-.015-.019-.028-.039-.042-.06a3.493 3.493 0 0 1-.481-1.986v-.6a3.338 3.338 0 0 1 .517-1.967m3.457.6h.086a1.8 1.8 0 0 0-.394-.693 2.055 2.055 0 0 1 .308.693",
    transform: "translate(-8.339 -6.362)",
    style: {
      fill: "#664039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59839",
    d: "M17 26.662h-2.761v2.1h3.232v.938h-4.4v-6.809h4.368v.955h-3.2v1.88H17z",
    transform: "translate(-3.888 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59840",
    d: "M25.618 23.846h-2.1V29.7h-1.16v-5.854h-2.08v-.955h5.34z",
    transform: "translate(-6.032 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59841",
    d: "M34.132 27.447a2.474 2.474 0 0 1-.8 1.7 2.688 2.688 0 0 1-1.844.611 2.607 2.607 0 0 1-1.417-.386 2.526 2.526 0 0 1-.946-1.1 4 4 0 0 1-.346-1.652v-.636a4.027 4.027 0 0 1 .337-1.7 2.564 2.564 0 0 1 .969-1.133 2.676 2.676 0 0 1 1.458-.4 2.4 2.4 0 0 1 2.589 2.349h-1.164a1.693 1.693 0 0 0-.423-1.059 1.389 1.389 0 0 0-1-.325 1.362 1.362 0 0 0-1.173.564 2.846 2.846 0 0 0-.417 1.655v.6a3.02 3.02 0 0 0 .39 1.686 1.291 1.291 0 0 0 1.144.58 1.5 1.5 0 0 0 1.036-.313 1.645 1.645 0 0 0 .439-1.044z",
    transform: "translate(-8.562 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59842",
    d: "M62.067 17.453h16.075L60.989 0v16.362a1.085 1.085 0 0 0 1.078 1.091",
    transform: "translate(-18.142)",
    style: {
      fill: "#ddd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEtc);
export default __webpack_public_path__ + "static/media/ico_etc.147ea6c65ec78669b4e8401cdfa76945.svg";
export { ForwardRef as ReactComponent };